// keyrd_console/src/components/PilotDataSourceBadge.js
import React from "react";

const TONE_MAP = {
  real: {
    background: "#dcfce7",
    color: "#166534",
    border: "1px solid #86efac",
    label: "Real",
  },
  stub: {
    background: "#fef3c7",
    color: "#92400e",
    border: "1px solid #fcd34d",
    label: "Stub",
  },
  mock: {
    background: "#e0e7ff",
    color: "#3730a3",
    border: "1px solid #a5b4fc",
    label: "Mock",
  },
  unknown: {
    background: "#f3f4f6",
    color: "#374151",
    border: "1px solid #d1d5db",
    label: "Unknown",
  },
};

const badgeStyle = (tone) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "4px 8px",
  fontSize: 12,
  fontWeight: 600,
  borderRadius: 999,
  background: tone.background,
  color: tone.color,
  border: tone.border,
  whiteSpace: "nowrap",
});

function normalizeSource(value) {
  if (!value) return "unknown";
  const lower = String(value).trim().toLowerCase();
  if (lower === "real") return "real";
  if (lower === "stub") return "stub";
  if (lower === "mock") return "mock";
  return "unknown";
}

function PilotDataSourceBadge({ source, stub = false, mock = false }) {
  let normalized = normalizeSource(source);

  if (stub) normalized = "stub";
  if (mock) normalized = "mock";

  const tone = TONE_MAP[normalized] || TONE_MAP.unknown;

  return <span style={badgeStyle(tone)}>Data Source: {tone.label}</span>;
}

export default PilotDataSourceBadge;